import styled, { keyframes } from 'styled-components'
import {
  AUTO_ADVANCE_DELAY_MS,
  CONFETTI_FALL_DISTANCE_PX,
} from '~/pages/anatomyV2/libs/components/SectionCompleteTemplate/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Progress } from '~/shared/components/Progress'
import { COLORS } from '~/shared/constants/uiConstants'

const confettiFall = keyframes`
  0% {
    transform: translateY(-24px) rotate(0deg);
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  100% {
    transform: translateY(${CONFETTI_FALL_DISTANCE_PX}px) rotate(360deg);
    opacity: 0;
  }
`

export const SectionCompleteTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    align-items: center;
    min-height: 0;
    padding: 16px;
  `,

  CelebrationContent: styled.div`
    position: relative;
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: safe center;
  `,

  ConfettiWrapper: styled.div`
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
  `,

  ConfettiPiece: styled.span<{
    $left: number
    $color: string
    $delay: number
    $duration: number
    $rotation: number
  }>`
    position: absolute;
    top: -12px;
    left: ${({ $left }) => $left}%;
    width: 7px;
    height: 12px;
    border-radius: 2px;
    background-color: ${({ $color }) => $color};
    opacity: 0;
    transform: rotate(${({ $rotation }) => $rotation}deg);
    animation: ${confettiFall} ${({ $duration }) => $duration}s ease-in
      ${({ $delay }) => $delay}s forwards;
  `,

  Image: styled.img`
    margin-bottom: 30px;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 10px;
  `,

  Subtitle: styled.p`
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 30px;
  `,

  Points: styled.p`
    color: #8c67f6;
    font-family: 'Mulish', sans-serif;
    font-size: 22px;
    line-height: 1;
    font-weight: 900;
    margin-bottom: 16px;
  `,

  ProgressWrapper: styled.div`
    width: 100%;
    height: 10px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #d4c5ff;
  `,

  AnimatedProgress: styled(Progress)`
    &::-webkit-progress-value {
      transition: width ${AUTO_ADVANCE_DELAY_MS}ms linear;
    }
    &::-moz-progress-bar {
      transition: width ${AUTO_ADVANCE_DELAY_MS}ms linear;
    }
  `,
}
